import 'react-datepicker/dist/react-datepicker.css';
import './FormDatePicker.module.scss';

import React from 'react';

import DatePicker from 'react-datepicker';

import { FormFieldWrapper } from 'components';

export const FormDatePicker = ({
  label,
  locale,
  readOnly,
  minDate,
  maxDate,
  input = {},
  meta = {},
}) => {
  const {
    value,
    onChange = () => {},
    onFocus = () => {},
    onBlur = () => {},
    ...restInput
  } = input;

  const { error, submitError, touched } = meta;
  const shouldDisplayError = !!((error || submitError) && touched);

  return (
    <FormFieldWrapper
      invalid={shouldDisplayError}
      label={label}
      error={error || submitError}
    >
      <DatePicker
        selected={input.value}
        onChange={date => input.onChange(date)}
         minDate={minDate || new Date()}
        className="custom-react-datepicker"
        locale={locale}
        onCalendarOpen={onFocus}
        onCalendarClose={onBlur}
        readOnly={readOnly}
        {...restInput}
      />
    </FormFieldWrapper>
  );
};

export default FormDatePicker;
